import { useEffect, useState } from 'react';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type {
	UploadContext,
	MediaContext,
} from '@atlassian/jira-issue-gira-transformer-types/src/common/types/media-context.tsx';
import transformUploadContext from '@atlassian/jira-issue-view-common-media/src/upload-context/upload-context-transformer.tsx';

type Milliseconds = number;

export type UploadToken = {
	endpointUrl: string;
	clientId: string;
	targetCollection: string;
	token: string;
	tokenDurationInMins: Milliseconds;
};

export const fetchResults = async (
	projectId: string,
	setData: (data: UploadToken) => void,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setError: (error: any) => void,
) => {
	try {
		const response = await performGetRequest(
			`/rest/api/2/attachment/upload/project/${projectId}/credentials`,
		);
		setData(response);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		setError(e);
	}
};

export const useFetchProjectToken = (
	projectId: string | undefined,
	mediaContext: MediaContext | undefined, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): { data: UploadContext | null; error: any } => {
	const [data, setData] = useState<UploadToken>();
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const [error, setError] = useState<any>(undefined);

	useEffect(() => {
		mediaContext && projectId && fetchResults(projectId, setData, setError);
	}, [projectId, mediaContext]);

	return { data: data ? transformUploadContext(data) : null, error };
};
